import { render, staticRenderFns } from "./cshome.vue?vue&type=template&id=582d23d2&scoped=true"
import script from "./cshome.vue?vue&type=script&lang=js"
export * from "./cshome.vue?vue&type=script&lang=js"
import style0 from "./cshome.vue?vue&type=style&index=0&id=582d23d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582d23d2",
  null
  
)

export default component.exports